// Renders ShortcutChords into platform-aware key-cap tokens for display.
// Cmd shows as ⌘ on Mac (universally recognised); Shift/Alt are spelled out so
// the modifier is obvious. Within a combo the caps are joined with "+".
const isMac = () => {
    if (typeof navigator === 'undefined')
        return false;
    const platform = navigator.platform || navigator.userAgent || '';
    return /Mac|iPhone|iPad|iPod/i.test(platform);
};
// Special-key glyph/label map. Single letters fall through to uppercase.
const KEY_LABELS = {
    ArrowUp: '↑',
    ArrowDown: '↓',
    ArrowLeft: '←',
    ArrowRight: '→',
    ' ': 'Space',
    Escape: 'Esc',
    Enter: 'Enter',
    Backspace: 'Backspace',
    Delete: 'Del',
    Home: 'Home',
};
const keyLabel = (key) => {
    if (KEY_LABELS[key])
        return KEY_LABELS[key];
    if (key.length === 1)
        return key.toUpperCase();
    return key;
};
const isArrow = (key) => key.startsWith('Arrow');
const modSignature = (c) => `${c.ctrlOrCmd ? 'c' : ''}${c.shift ? 's' : ''}${c.alt ? 'a' : ''}`;
const modifierTokens = (c, mac) => {
    const tokens = [];
    if (c.ctrlOrCmd)
        tokens.push(mac ? '⌘' : 'Ctrl');
    if (c.shift)
        tokens.push('Shift');
    if (c.alt)
        tokens.push(mac ? 'Option' : 'Alt');
    return tokens;
};
// Ordered cap tokens for one chord, e.g. ['⌘', 'Shift', 'P'].
export const formatChord = (chord) => [
    ...modifierTokens(chord, isMac()),
    keyLabel(chord.key),
];
// Display segments for a whole shortcut. Multiple segments are alternatives
// (rendered with a "/" between them). Arrow chords that share the same modifiers
// collapse into ONE segment — e.g. Pan renders as a single ↑ ↓ ← → cluster.
export const formatShortcutKeys = (chords) => {
    const mac = isMac();
    const allArrows = chords.length > 1
        && chords.every(c => isArrow(c.key))
        && chords.every(c => modSignature(c) === modSignature(chords[0]));
    if (allArrows) {
        return [{
                mods: modifierTokens(chords[0], mac),
                keys: chords.map(c => keyLabel(c.key)),
            }];
    }
    return chords.map(c => ({
        mods: modifierTokens(c, mac),
        keys: [keyLabel(c.key)],
    }));
};
